import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { publicUser } from "../../../../../globals/route-names";
import JobZImage from "../../../../common/jobz-img";

import SectionPagination from "../../sections/common/section-pagination";
import SectionRecordsFilter from "../../sections/common/section-records-filter";
import SectionCandidatesSidebar from "../../sections/jobs/sidebar/section-candidates-sidebar";
import { jobService } from "../../../../../services/job-service";
import { loadScript } from "../../../../../globals/constants";

function CandidateGridPage() {
    const [candidates, setCandidates] = useState([]);
    const [categories, setCategories] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [pageSize] = useState(10);
    const [loading, setLoading] = useState(true);
    const [filters, setFilters] = useState({
        category: "",
        subcategory: "",
        keyword: "",
        location: ""
    });

    useEffect(() => {
        jobService.jobCategories()
            .then((data) => setCategories(data.categories || []))
            .catch(console.error);
    }, []);

    useEffect(() => {
        setLoading(true);
        jobService.candidates({ ...filters, page, pageSize })
            .then((data) => {
                setCandidates(data.candidates || []);
                setTotal(data.total || 0);
            })
            .catch(console.error)
            .finally(() => setLoading(false));
    }, [filters, page, pageSize]);

    useEffect(() => {
        loadScript("js/custom.js");
    });

    const _filterConfig = {
        prefix: "Showing",
        type: "Candidates",
        total: `${total}`,
        showRange: false,
        showingUpto: ""
    };

    return (
        <>
            <div className="section-full p-t120  p-b90 site-bg-white">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-12 rightSidebar">
                            <SectionCandidatesSidebar filters={filters} onChange={setFilters} categories={categories} />
                        </div>
                        <div className="col-lg-8 col-md-12">
                            <SectionRecordsFilter _config={_filterConfig} />

                            <div className="twm-candidates-grid-wrap">
                                {loading ? (
                                    <div className="text-center p-a30">Loading candidates...</div>
                                ) : candidates.length === 0 ? (
                                    <div className="text-center p-a30">No candidates found matching the criteria.</div>
                                ) : (
                                    <div className="row">
                                        {candidates.map((candidate) => (
                                            <div key={candidate.id} className="col-lg-6 col-md-6">
                                                <div className="twm-candidates-grid-style1 mb-5">
                                                    <div className="twm-media">
                                                        <div className="twm-media-pic">
                                                            <JobZImage src={candidate.avatar_url || "images/user-avtar/pic4.jpg"} alt={candidate.name} />
                                                        </div>
                                                    </div>
                                                    <div className="twm-mid-content">
                                                        <div className="twm-job-title">
                                                            <h4>{candidate.name}</h4>
                                                        </div>
                                                        <p>{candidate.headline || "Job Seeker"}</p>
                                                        <div className="twm-fot-content">
                                                            <div className="twm-left-info">
                                                                <p className="twm-candidate-address"><i className="feather-map-pin" />{candidate.location || "Not Specified"}</p>
                                                                {candidate.skills && (
                                                                    <div className="twm-candidate-skills small text-muted m-t5">
                                                                        <strong>Skills:</strong> {candidate.skills}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            <SectionPagination 
                                page={page}
                                total={total}
                                pageSize={pageSize}
                                onPageChange={(p) => setPage(p)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CandidateGridPage;